module.exports = __webpack_public_path__ + "static/media/curva.3ae93cf4.jpg";